import { render, staticRenderFns } from "./ExternalOrders.vue?vue&type=template&id=8662186c&scoped=true"
import script from "./ExternalOrders.vue?vue&type=script&lang=js"
export * from "./ExternalOrders.vue?vue&type=script&lang=js"
import style0 from "./ExternalOrders.vue?vue&type=style&index=0&id=8662186c&prod&lang=scss&scoped=true"
import style1 from "./ExternalOrders.vue?vue&type=style&index=1&id=8662186c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8662186c",
  null
  
)

export default component.exports